import getItems from './getItems'
import getSiteConfig from './getSiteConfig'
import set from './set'

export default {
  ...getItems,
  ...getSiteConfig,
  ...set
}
